var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationScale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M44.481 21.876l-.962-1.752 20-11 .962 1.752-20 11M16.481 36.876l-.962-1.752 20-11 .962 1.752-20 11",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.083 56A6.01 6.01 0 0016 61a6.01 6.01 0 005.917-5H10.083zM16 63c-4.411 0-8-3.589-8-8v-1h16v1c0 4.411-3.589 8-8 8z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 52h-2v-1.827l-4-11.2-4 11.2V52h-2v-2c0-.115.02-.229.059-.336l5-14a.998.998 0 011.882 0l5 14A.982.982 0 0122 50v2",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.083 30A6.01 6.01 0 0064 35a6.01 6.01 0 005.917-5H58.083zM64 37c-4.411 0-8-3.589-8-8v-1h16v1c0 4.411-3.589 8-8 8z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 26h-2v-1.827l-4-11.2-4 11.2V26h-2v-2c0-.115.02-.229.059-.336l5-14a.998.998 0 011.882 0l5 14A.982.982 0 0170 24v2M58 71H22a1 1 0 01-1-1c0-2.757 2.243-5 5-5h11V28h2v38a1 1 0 01-1 1H26a3.006 3.006 0 00-2.829 2h33.658A3.006 3.006 0 0054 67H42a1 1 0 01-1-1V28h2v37h11c2.757 0 5 2.243 5 5a1 1 0 01-1 1M39 24h2v-2h-2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 19c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 10c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zM8 71h64v-2H8z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationScale;